import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { DebugMenuReport, DebugMenuState } from './types';

const initialState: DebugMenuState = {
    report: { drawingPerformance: null },
    drawConferenceDisabled: false,
};

const debugMenuSlice = createSlice({
    name: 'dtmf-debug-menu',
    initialState,
    reducers: {
        setDebugMenuStatsReport(state: DebugMenuState, action: PayloadAction<DebugMenuReport>) {
            state.report = action.payload;
        },
        setDrawConferenceDisabledValue(state: DebugMenuState, action: PayloadAction<boolean>) {
            state.drawConferenceDisabled = action.payload;
        },
        hideDebugMenu() {
            return { ...initialState };
        },
    },
});

export const debugMenuActions = debugMenuSlice.actions;

export const debugMenuReducer = debugMenuSlice.reducer;
